import { reactive } from '@vue/composition-api'

const userColors = reactive({})
const colorPalette = ['#FF6B6B', '#6BCB77', '#4D96FF', '#FFD93D', '#F38BA0', '#845EC2', '#00C9A7', '#F9A826', '#2C73D2', '#0081CF', '#C34A36', '#D65DB1', '#009EFA', '#FFC75F', '#B5E48C', '#2F4858']
function getRandomColor(index) {
  return colorPalette[index % colorPalette.length]
}

export function assignColorToUser(userId) {
  if (!userColors[userId]) {
    const nextIndex = Object.keys(userColors).length
    userColors[userId] = getRandomColor(nextIndex)
  }
  return userColors[userId]
}

export function useUserColors() {
  return { assignColorToUser, userColors }
}
